(function (angular) {
    'use strict';

    /* Sample payloads
    {
      "once": {
        "startOn": "2018-07-05T23:00:00.000Z"
      }
    }
    
    {
      "recurring": {
        "frequency": "hour",
        "interval": 1,
        "startOn": "2018-07-06T06:37:39.524Z",
        "endOn": "2018-07-06T23:00:00.000Z",
        "minutes": [
          10
        ]
      }
    }
    
    {
      "recurring": {
        "frequency": "day",
        "interval": 1,
        "startOn": "2018-07-06T06:37:39.524Z",
        "endOn": "2018-07-06T23:00:00.000Z",
        "times": [
          "12:00"
        ]
      }
    }
    
    {
      "recurring": {
        "frequency": "week",
        "interval": 1,
        "startOn": "2018-07-06T06:37:39.524Z",
        "endOn": "2018-07-06T23:00:00.000Z",
        "daysOfWeek": [
          "wed"
        ],
        "times": [
          "12:00"
        ]
      }
    }
    
    {
      "recurring": {
        "frequency": "month",
        "interval": 1,
        "startOn": "2018-07-06T06:37:39.524Z",
        "endOn": "2018-07-06T23:00:00.000Z",
        "daysOfMonth": [
          "15"
        ],
        "times": [
          "12:00"
        ]
      }
    }
    */



    angular.module('broadcast')
        /**
         * 
         */
        .directive('scheduler', ["moment",
            function (moment) {

                var daysOfWeek = [{
                    value: "sun",
                    label: "Sunday",
                }, {
                    value: "mon",
                    label: "Monday",
                }, {
                    value: "tue",
                    label: "Tuesday",
                }, {
                    value: "wed",
                    label: "Wednesday",
                }, {
                    value: "thu",
                    label: "Thursday",
                }, {
                    value: "fri",
                    label: "Friday",
                }, {
                    value: "sat",
                    label: "Saturday",
                }];

                //buttons
                var scheduleOptions = [
                    {
                        label: "Immediately",
                        value: "immediately",
                    },
                    {
                        label: "Once",
                        value: "once",
                    }, {
                        label: 'Hourly',
                        value: 'hour',
                    }, {
                        label: 'Daily',
                        value: 'day',
                    }, {
                        label: 'Weekly',
                        value: 'week',
                    }, {
                        label: 'Monthly',
                        value: 'month',
                    }];


                /**
                 * given an iso date, return hh:mm
                 */
                function extractTime(isoDate) {
                    var m = moment(isoDate);
                    return m.format("HH:mm");
                }

                /**
                 * 
                 * @param {*} model
                 */
                function serialiseToJson(schedule) {
                    try {
                        if (schedule.recurringOption === "immediately") {
                            return undefined;
                        }
                        else if (schedule.recurringOption === "once") {
                            var date;

                            if (schedule.timezone) {
                                date = moment().tz(schedule.timezone);
                                var day = moment(schedule.day);
                                date.year(day.year()).month(day.month()).date(day.date());

                            } else {
                                date = moment(schedule.day);
                            }

                            date.hours(schedule.time.hours()).minutes(schedule.time.minutes()).second(0).millisecond(0);

                            var result = {
                                "once": {
                                    startOn: date.toISOString()
                                }
                            }

                            if (schedule.timezone) {
                                result.once.timezone = schedule.timezone;
                            }

                            return result
                        } else {

                            var data = {
                                "recurring": {
                                    "frequency": schedule.recurringOption,
                                    "interval": 1,
                                    // all have startOn and endOn ...
                                    "startOn": moment(schedule.startOn).startOf('day').toISOString(),
                                    "endOn": schedule.endOn && schedule.endOn.toISOString(),
                                    timezone: schedule.timezone
                                }
                            }

                            switch (schedule.recurringOption) {
                                case "hour":
                                    data.recurring.minutes = [schedule.minutes];
                                    break;
                                case "day":
                                    data.recurring.times = [extractTime(schedule.time)];
                                    break;
                                case "week":
                                    data.recurring.times = [extractTime(schedule.time)];
                                    data.recurring.daysOfWeek = [schedule.dayOfWeek];
                                    break;
                                case "month":
                                    data.recurring.times = [extractTime(schedule.time)];
                                    data.recurring.daysOfMonth = [String(schedule.dayOfMonth)];
                                    break;
                            }
                        }

                        return data;

                    } catch (e) {
                        return undefined;
                    }
                }

                /**
                 * 
                 */
                function setTime(time) {
                    var now = moment();

                    var rslt = time.split(":");

                    return now.set({
                        'hour': rslt[0],
                        'minute': rslt[1],
                    });
                }

                /**
                 * 
                 * @param {*} json 
                 */
                function serialiseToModel($scope, data) {
                    //initialize timezone
                    if (data && data.recurring) {
                        $scope._schedule.timezone = data.recurring.timezone ? data.recurring.timezone : moment.tz.guess();
                    } else if (data && data.once) {
                        $scope._schedule.timezone = data.once.timezone ? data.once.timezone : moment.tz.guess();
                    } else {
                        $scope._schedule.timezone = moment.tz.guess();
                    }


                    if (!data) {
                        $scope._schedule.recurringOption = "immediately";
                    } else if (data.once) {
                        $scope._schedule.recurringOption = "once";
                        if ($scope._schedule.timezone) {
                            var timezoneTime = moment(data.once.startOn).tz($scope._schedule.timezone);
                            var hours = timezoneTime.hours();
                            var minutes = timezoneTime.minutes();
                            $scope._schedule.time = moment(data.once.startOn).hours(hours).minutes(minutes);
                        } else {
                            $scope._schedule.time = moment(data.once.startOn);
                        }
                        // $scope._schedule.time = $scope._schedule.timezone ? moment(data.once.startOn).tz($scope._schedule.timezone) : moment(data.once.startOn);
                        $scope._schedule.day = new Date(moment.utc(data.once.startOn).startOf('day'));
                    } else if (data.recurring) {

                        // all recurring options share this data:
                        $scope._schedule.recurringOption = data.recurring.frequency;
                        $scope._schedule.startOn = new Date(moment.utc(data.recurring.startOn));
                        // endOn is optional
                        $scope._schedule.endOn = data.recurring.endOn && new Date(moment.utc(data.recurring.endOn));



                        switch (data.recurring.frequency) {

                            case "hour":
                                $scope._schedule.minutes = data.recurring.minutes[0];
                                break;

                            case "day":
                                $scope._schedule.time = setTime(data.recurring.times[0]);
                                break;

                            case "week":
                                $scope._schedule.dayOfWeek = data.recurring.daysOfWeek[0];
                                $scope._schedule.time = setTime(data.recurring.times[0]);
                                break;

                            case "month":
                                $scope._schedule.dayOfMonth = data.recurring.daysOfMonth[0];
                                $scope._schedule.time = setTime(data.recurring.times[0]);
                                break;
                        }
                    }

                }


                var linkFn = function ($scope, element, attrs, form) {

                    $scope.form = form;


                    $scope.timeZones = moment.tz.names();
                    $scope._schedule = {};

                    $scope.showError = function (name) {
                        return form[name].$invalid;
                    }

                    $scope.scheduleOptions = scheduleOptions;
                    $scope.daysOfWeek = daysOfWeek;
                    $scope.daysOfMonth = [];

                    for (var i = 1; i <= 31; i++) {
                        $scope.daysOfMonth.push(i);
                    }

                    serialiseToModel($scope, $scope.schedule);

                    $scope.changeHander = function () {
                        if (form.$valid) {
                            $scope.schedule = serialiseToJson($scope._schedule);
                        } else {
                            console.error("_schedule changed but form was invalid")
                        }
                    }
                };

                return {
                    restrict: 'EA', //Default in 1.3+
                    require: '^form'/*, 'ngModel'*/,
                    scope: {
                        schedule: "=",
                        showInvalid: "="
                    },
                    link: linkFn,
                    templateUrl: 'components/toolkit/broadcast/templates/directive.scheduler.html'
                };


            }])




})(window.angular);